const ADJECTIVES = [
  'BRAVE',
  'CAREFUL',
  'CHATTY',
  'CLEVER',
  'FUNNY',
  'GENTLE',
  'GRUMPY',
  'HAPPY',
  'LOVELY',
  'LOYAL',
  'LUCKY',
  'SILLY',
  'SLEEPY',
  'SNEAKY',
  'SNEEZY',
  'TIDY',
  'WILD',
  'WISE',
  'WITTY',
] as const;

const ANIMALS = [
  'BEAR',
  'CAT',
  'DOG',
  'DUCK',
  'FOX',
  'FROG',
  'GOOSE',
  'HIPPO',
  'HORSE',
  'MONKEY',
  'MOOSE',
  'MOUSE',
  'RABBIT',
  'SALMON',
  'SHARK',
  'SQUIRREL',
  'TURTLE',
  'UNICORN',
] as const;

export const generateRandomKeyword = (): string =>
  `${ADJECTIVES[Math.round(Math.random() * (ADJECTIVES.length - 1))]} ${
    ANIMALS[Math.round(Math.random() * (ANIMALS.length - 1))]
  }`;
